// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2uPTF","imageUploader":"EGiftCard_imageUploader__3z6M4"};